import {
  Table as UITable,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatToBRL } from "@/utils/formatToMoney";

import type { IAggregationByStore } from "src/@types/deposit-reconciliation";

import { sumAmountsInCents } from "./sum-in-cents";

const STATUS_COLORS: Record<string, string> = {
  ABERTO: "text-rose-700 bg-rose-50 border-rose-200",
  AGUARDANDO: "text-yellow-700 bg-yellow-50 border-yellow-200",
  FECHADO: "text-emerald-700 bg-emerald-50 border-emerald-200",
};

export default function AggregationByStore({
  rows,
}: {
  rows: IAggregationByStore[];
}) {
  const total = {
    conc: sumAmountsInCents(rows, r => r.conciliado),
    ab: sumAmountsInCents(rows, r => r.aberto),
  };

  return (
    <div className="border border-slate-200 rounded-md bg-white">
      <div className="border-b border-slate-200 px-3 py-2 bg-slate-50">
        <h3 className="font-semibold text-sm text-slate-700">Por Loja</h3>
      </div>
      <div className="max-h-96 overflow-y-auto">
        <UITable>
          <TableHeader>
            <TableRow>
              <TableHead className="text-xs">Loja</TableHead>
              <TableHead className="text-xs text-right">Conciliado</TableHead>
              <TableHead className="text-xs text-right">Em aberto</TableHead>
              <TableHead className="text-xs">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-xs text-center text-slate-500">
                  Sem dados
                </TableCell>
              </TableRow>
            ) : (
              <>
                {rows.map(r => (
                  <TableRow key={r.storeCode}>
                    <TableCell className="text-xs">
                      {r.storeCode}
                      {r.storeName ? ` — ${r.storeName}` : ""}
                    </TableCell>
                    <TableCell className="text-xs text-right">
                      {formatToBRL(r.conciliado)}
                    </TableCell>
                    <TableCell className="text-xs text-right">
                      {formatToBRL(r.aberto)}
                    </TableCell>
                    <TableCell>
                      <span
                        className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-medium whitespace-nowrap ${STATUS_COLORS[r.status] ?? ""}`}
                      >
                        {r.status}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow className="bg-slate-50 font-semibold border-t-2 border-[#2B0C1A]">
                  <TableCell className="text-xs">TOTAL</TableCell>
                  <TableCell className="text-xs text-right">
                    {formatToBRL(total.conc)}
                  </TableCell>
                  <TableCell className="text-xs text-right">
                    {formatToBRL(total.ab)}
                  </TableCell>
                  <TableCell />
                </TableRow>
              </>
            )}
          </TableBody>
        </UITable>
      </div>
    </div>
  );
}
